import { AUTH_API } from "../vars";
import { reverseString } from "../utils";

/***
 *  Creates salt on the client and the server
 * @param password {String}
 * @param callback {Function}
 */

export async function establishSecurityDialog(password, callback) {
    return fetch(`${AUTH_API}/dialog`, {
        method: 'POST'
    })
        .then(response => response.json())
        .then(dialog => {
            const dialogId = dialog.id;
            const serverSecret = dialog.serverSecret;
            const clientSecret = generateClientSecret();

            return fetch(`${AUTH_API}/dialog/client-secret`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: dialogId,
                    clientSecret,
                })
            })
                .then(response => response.json())
                .then(({ id }) => {
                    password = insertSecretKeysIntoPassword(reverseString(password), clientSecret, serverSecret);
                    // alert ('id: '+id+'  -Password: '+password)
                    return callback(id, password)
                })
        })
}
//Added by octopus DevTeam on March 17,2022
export async function establishSecurityDialogs(passwords, callback) {
    // eslint-disable-next-line no-array-constructor
    let encryptedPasswords = new Array();
    return fetch(`${AUTH_API}/dialog`, {
        method: 'POST'
    })
        .then(response => response.json())
        .then(dialog => {

            const dialogId = dialog.id;
            const serverSecret = dialog.serverSecret;
            const clientSecret = generateClientSecret();

            return fetch(`${AUTH_API}/dialog/client-secret`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: dialogId,
                    clientSecret,
                })
            })
                .then(response => response.json())
                .then(({ id }) => {
                    encryptedPasswords.push(insertSecretKeysIntoPassword(reverseString(passwords[0]), clientSecret, serverSecret));
                    encryptedPasswords.push(insertSecretKeysIntoPassword(reverseString(passwords[1]), clientSecret, serverSecret));
                    return callback(id, encryptedPasswords)
                })
        })
}


export function generateClientSecret() {
    const maxLength = 6;
    const minLength = 4;

    const secretLength = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

    const randomString = Math
        .random()
        .toString(36)
        .substring(2, 15) + Math.random()
            .toString(36)
            .substring(2, 15)

    return randomString.substring(0, secretLength);
}

export function insertSecretKeysIntoPassword(password, clientSecret, serverSecret) {

    const clientSecretInsertedPassword = password.slice(0, clientSecret.length - 1)
        + reverseString(clientSecret)
        + password.slice(clientSecret.length - 1);
    return clientSecretInsertedPassword
        .slice(0, serverSecret.length - 1)
        + reverseString(serverSecret)
        + clientSecretInsertedPassword.slice(serverSecret.length - 1);
}
